/* eslint-disable react-hooks/exhaustive-deps */
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import LoopIcon from "@mui/icons-material/Loop";
import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Skeleton,
  useMediaQuery,
} from "@mui/material";
import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Search from "../../../components/inputs/search";
import PageTitle from "../../../components/pageTitle";
import {
  handleAllProducts,
  handleLogOut,
  resetAllSummeryData,
} from "../../../redux/actoin";
import { API } from "../../../scripts/api";
import axiosInstance from "../../../scripts/axiosInspector";
import ProductCart from "./cart";

const Products = () => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const allProducts = useSelector((state) => state.allProducts);
  const { products } = allProducts;
  const [productData, setProductData] = useState({});
  const [productDataPure, setProductDataPure] = useState({});
  const isMd = useMediaQuery("(min-width:756px)");
  const [searchData, setSearchData] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [loadingCsv, setLoadingCsv] = useState(false);
  const [filtering, setFilterIng] = useState(1);
  const [comment, setComment] = useState("");
  const navigate = useNavigate();
  const getData = () => {
    setLoading(true);
    axiosInstance
      .get(API.info.productList + `?guidStateRecNo=${company?.guidRecNo}`, {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "Accept-Language": "fa-IR",
          chHostName: process.env.REACT_APP_CHHOSTNAME,
        },
      })
      .then((res) => {
        setProductData(res?.data?.data);
        dispatch(handleAllProducts(res?.data?.data));
        setProductDataPure(res?.data?.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        /*       if (err.response.status === 401 || err.response.status === 403) {
          dispatch(handleLogOut());
        } */
      });
  };
  useMemo(() => {
    if (userInfo) {
      if (products?.page !== undefined) {
        setProductData({ ...products });
        setProductDataPure({ ...products });
      } else {
        getData();
      }
    }
  }, [userInfo, company?.guidRecNo]);

  const handleRemove = (item) => {
    setLoadingRemove(true);
    var temp = [...productData.rows];
    axiosInstance
      .delete(
        API.info.product,

        {
          data: { chDeletedComment: comment, guidRecNo: item.guidRecNo },
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        temp = temp.filter((it) => it.guidRecNo !== item.guidRecNo);
        setProductData({ ...productData, rows: temp });
        dispatch(resetAllSummeryData());
        setLoadingRemove(false);
      })
      .catch((err) => {
        setLoadingRemove(false);
      });
  };
  const downloadExcel = () => {
    if (userInfo) {
      setLoadingCsv(true);
      axiosInstance
        .get(
          API.info.productList +
            `?guidStateRecNo=${company?.guidRecNo}&exportFormat=Excel`,
          {
            headers: {
              Authorization: `Bearer ${userInfo?.token}`,
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
              "Accept-Language": "fa-IR",
              chHostName: process.env.REACT_APP_CHHOSTNAME,
            },
          }
        )
        .then((res) => {
          const base64Data = res.data.data.chExportFile; // Replace with actual base64 data
          DownloadDocument(1, "Excel", base64Data);
          setLoadingCsv(false);
        })
        .catch((err) => {
          setLoadingCsv(false);
          if (err.response.status === 401 || err.response.status === 403) {
            dispatch(handleLogOut());
          }
        });
    }
  };
  useEffect(() => {
    handleFilter();
  }, [filtering]);
  const DownloadDocument = (title, exportFormat, base64Doc) => {
    let extension = ".txt";
    switch (exportFormat) {
      case "Excel":
        extension = ".xlsx";
        break;
      default:
        extension = ".txt";
        break;
    }
    var a = document.createElement("a");
    a.href = base64Doc;
    a.download =
      `خروجی کالا/خدمت${new Date().toLocaleDateString("fa-IR")}` + extension;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  const handleFilter = () => {
    if (filtering === 1) {
      setProductData(productDataPure);
    } else if (filtering === 2) {
      var temp = [...productDataPure.rows];
      temp = temp.filter((item) => item.btDisabled === false);
      setProductData({ ...productData, rows: temp });
    } else if (filtering === 3) {
      var temp2 = [...productDataPure.rows];
      temp2 = temp2.filter((item) => item.btDisabled === true);
      setProductData({ ...productData, rows: temp2 });
    }
  };
  const handleSearch = (event) => {
    setSearchData(event.target.value);
    if (event.target.value === "") {
      handleFilter();
    } else {
      var temp = [...productData.rows];

      const search = (query) =>
        temp.filter(
          (s) =>
            s.chTitle?.includes(query) ||
            s.chName?.includes(query) ||
            String(s.chSaleSoftID)?.includes(query) ||
            String(s.moUnitPrice)?.includes(query) ||
            String(s.chCode)?.includes(query)
        );

      setProductData({ ...productData, rows: search(event.target.value) });
    }
  };
  return (
    <>
      {" "}
      <PageTitle
        broadCrumb={[
          {
            title: "فروش",
            path: "/sell",
          },
        ]}
        title={"کالا/خدمت"}
      />
      <Paper className="mx-3 my-5 border py-3 px-3 relative z-40" elevation={1}>
        <div className="flex flex-row  justify-between md:items-center gap-4">
          <FormControl
            sx={{
              ".MuiTypography-root": { fontSize: "0.8rem !important" },
              ".MuiButtonBase-root": {
                padding: "4px !important",
              },
              ".MuiFormControlLabel-root": {
                marginRight: "9px !important",
              },
            }}
          >
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                onClick={() => setFilterIng(1)}
                control={<Radio checked={filtering === 1} size="small" />}
                label="همه"
              />
              <FormControlLabel
                onClick={() => setFilterIng(2)}
                control={<Radio checked={filtering === 2} size="small" />}
                label="فعال"
              />
              <FormControlLabel
                onClick={() => setFilterIng(3)}
                control={<Radio checked={filtering === 3} size="small" />}
                label="غیر فعال"
              />
            </RadioGroup>
          </FormControl>
          <div className="flex justify-end gap-2 sm:justify-end items-center">
            <Button
              sx={{ padding: "5px !important", minWidth: "40px !important" }}
              onClick={downloadExcel}
              variant="contained"
              color="primary"
              disabled={loadingCsv}
            >
              {loadingCsv ? (
                <CircularProgress sx={{ mr: "2px" }} size={20} />
              ) : (
                <DownloadIcon />
              )}

              {/*      <span> خروجی اکسل </span> */}
            </Button>
            <Button
              sx={{ padding: "5px !important", minWidth: "40px !important" }}
              onClick={() => navigate("/sell/products/create")}
              variant="contained"
            >
              <AddIcon />
              {/*      <span>افزودن کالا/خدمت </span> */}
            </Button>
          </div>
        </div>
      </Paper>
      <Paper
        className="mx-3 relative z-40 min-h-[60vh] mt-6 pb-10 mb-6 border"
        elevation={1}
      >
        <div className="flex flex-col gap-4 sm:grid sm:grid-cols-2 lg:grid-cols-3 p-2">
          {loading ? (
            <>
              <Skeleton
                variant="rounded"
                width={"100%"}
                animation="wave"
                height={140}
              />{" "}
              <Skeleton
                variant="rounded"
                width={"100%"}
                animation="wave"
                height={140}
              />{" "}
              <Skeleton
                variant="rounded"
                width={"100%"}
                animation="wave"
                height={140}
              />
            </>
          ) : (
            <>
              <div className="sm:col-span-2 lg:col-span-3 ">
                <div className=" border-b pb-2 mb-2  ">
                  <div className=" flex items-end justify-between gap-4">
                    {" "}
                    <div className="flex gap-1 mt-5 items-center">
                      <span className="text-sm font-bold text-main">
                        تعداد موارد یافت شده :‌
                      </span>
                      <span className="text-sm font-bold text-main">
                        {productData?.rows?.length}
                      </span>
                    </div>
                    {isMd && (
                      <div className="mt-4">
                        <Search
                          search={searchData}
                          setSearch={(e) => handleSearch(e)}
                        />
                      </div>
                    )}
                    <div onClick={() => getData()}>
                      <LoopIcon
                        color="primary"
                        sx={{
                          color: (theme) =>
                            theme.palette.mode === "light"
                              ? ""
                              : "#fff  !important",
                        }}
                      />
                    </div>
                  </div>
                  {!isMd && (
                    <div className="mt-4">
                      <Search
                        search={searchData}
                        setSearch={(e) => handleSearch(e)}
                      />
                    </div>
                  )}
                </div>
              </div>

              {productData?.rows?.map((item) => (
                <Fragment key={item?.guidRecNo}>
                  <ProductCart
                    items={item}
                    columns={productData.columns}
                    removeHandle={() => handleRemove(item)}
                    setComment={setComment}
                    comment={comment}
                    loadingRemove={loadingRemove}
                  />
                </Fragment>
              ))}
            </>
          )}
        </div>
      </Paper>
    </>
  );
};

export default Products;
